export default "__VITE_ASSET__B1Ey2yHJ__"